import { render, staticRenderFns } from "./NoService.vue?vue&type=template&id=4073f432&scoped=true"
import script from "./NoService.vue?vue&type=script&lang=js"
export * from "./NoService.vue?vue&type=script&lang=js"
import style0 from "./NoService.vue?vue&type=style&index=0&id=4073f432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073f432",
  null
  
)

export default component.exports